import { TranslateFunction } from '~/Locale';
import { VehicleTypeRecord } from '~/config/generated/graphql';
import { VehicleType } from '~/App/shared/interfaces/ProcessObject';
import { WarrantyType } from './calculator';

export const getWarrantyHeading = (
  warrantyType: WarrantyType,
  t: TranslateFunction
) => {
  switch (warrantyType) {
    case 'xtra':
      return t('WARRANTY_CALCULATOR_SERVICE_XTRA_HEADING');
    case 'maxi':
      return t('WARRANTY_CALCULATOR_SERVICE_MAXI_HEADING');
    case 'bas':
    default:
      return t('WARRANTY_CALCULATOR_SERVICE_BAS_HEADING');
  }
};

export const getWarrantyDescription = (
  warrantyType: WarrantyType,
  t: TranslateFunction
) => {
  switch (warrantyType) {
    case 'xtra':
      return t('WARRANTY_CALCULATOR_SERVICE_XTRA_PRICE');
    case 'maxi':
      return t('WARRANTY_CALCULATOR_SERVICE_MAXI_PRICE');
    case 'bas':
    default:
      return t('WARRANTY_CALCULATOR_SERVICE_BAS_PRICE');
  }
};

export const isServiceExcludedForVehicleType = (
  excludeFromVehicleTypes?: Pick<VehicleTypeRecord, 'name'>[] | null,
  vehicleType?: VehicleType | null
) => {
  if (!vehicleType || !excludeFromVehicleTypes?.length) {
    return false;
  }

  return excludeFromVehicleTypes.some(({ name }) => name === vehicleType);
};
